import { render, staticRenderFns } from "./MyDocuments.vue?vue&type=template&id=1b0fdc99&"
import script from "./MyDocuments.vue?vue&type=script&lang=ts&"
export * from "./MyDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports